import React from 'react'
import Link from 'gatsby-link'
import { observer, inject } from 'mobx-react'
import { Container, Grid, List } from 'semantic-ui-react'
import { Share } from 'react-twitter-widgets'
import LazyLoad from 'react-lazyload'

const Footer = ({ UserStore, ...rest }) => (
  <div className='footer'>
    <Container text textAlign='center'>
      <small>
        <i>Remember</i>, this is not a real ticket - but looks 💯% like one.
      </small>
    </Container>
    <Container text textAlign='center'>
      <List horizontal divided>
        <List.Item as={Link} to='/'>
          Fake Ticket Generator
        </List.Item>
        {/* <List.Item as={Link} to='/referrals'>
          Affiliate
        </List.Item> */}
        <List.Item as={Link} to='/terms'>
          Terms & Privacy
        </List.Item>
        {/* <List.Item as={Link} to="/blog">
          Blog
        </List.Item> */}
        {/* <List.Item as={Link} to="/account">
          {UserStore.user ? 'Account' : 'Log in'}
        </List.Item> */}
        <List.Item as={Link} to='/faq'>
          Read FAQ before contacting us
        </List.Item>
        <List.Item
          as={Link}
          onClick={() => {
            window.location.href = 'mailto:support@fakeflighttickets.com'
          }}>
          Contact support
        </List.Item>
      </List>
    </Container>
    <Container text textAlign='center'>
      <LazyLoad once>
        <Share url='https://www.fakeflighttickets.com' />
        {/* <img src='https://en.bitcoin.it/w/images/en/f/fd/BC_nBG_64px.png' width='120' /> */}
      </LazyLoad>
    </Container>
  </div>
)

export default inject('UserStore')(observer(Footer))



// WEBPACK FOOTER //
// ./src/components/footer.js